import type * as THREE from 'three';
import { createCanvas, canvasTexture } from './canvas';

let cached: THREE.CanvasTexture | null = null;

export function getStarSprite(): THREE.CanvasTexture {
  if (cached) return cached;
  const size = 96;
  const { canvas, ctx } = createCanvas(size, size);
  const cx = size / 2;
  const cy = size / 2;

  const core = ctx.createRadialGradient(cx, cy, 0, cx, cy, size * 0.5);
  core.addColorStop(0.0, 'rgba(255,255,255,1)');
  core.addColorStop(0.25, 'rgba(255,255,255,0.85)');
  core.addColorStop(0.5, 'rgba(255,255,255,0.25)');
  core.addColorStop(1.0, 'rgba(255,255,255,0)');
  ctx.fillStyle = core;
  ctx.fillRect(0, 0, size, size);

  ctx.globalCompositeOperation = 'lighter';
  ctx.strokeStyle = 'rgba(255,255,255,0.55)';
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  ctx.moveTo(cx, cy - size * 0.42);
  ctx.lineTo(cx, cy + size * 0.42);
  ctx.moveTo(cx - size * 0.42, cy);
  ctx.lineTo(cx + size * 0.42, cy);
  ctx.stroke();

  cached = canvasTexture(canvas);
  return cached;
}
